import template from './admin-fax-search-results.html';
import adminConstants from '../../admin-constants';
import {indexedFaxStatuses} from '../fax-statuses';
import {adminStates} from './../../admin-routes';

const DIRECTIVE_NAME = AdminFaxSearchResults.DIRECTIVE_NAME = 'ktAdminFaxSearchResults';
export default function AdminFaxSearchResults() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: AdminFaxSearchResultsController,
        controllerAs: 'adminFaxSearchResultsCtrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
        },
        link: function($scope, $elem, $attrs, adminFaxSearchResultsCtrl) {
            adminFaxSearchResultsCtrl.$onInit();
        },
    };
}

export function AdminFaxSearchResultsController(
    $state,
    $stateParams,
    $window,
    adminFaxSearchService
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        isNoResultsLabelVisible,
        isLoadMoreButtonVisible,
        isResendFaxesDisabled,
        isResendBtnVisible,
        loadMore,
        onSelectAll,
        onFaxSelect,
        resendFaxes,
        getStatusIconClass,
        navigateToFaxViewPage,
    });

    function resendFaxes() {
        adminFaxSearchService.resendFaxes(vm.faxesToResend)
            .then(() => {
                vm.faxesToResend = [];
                $window.alert('Selected document(s) were successfully resent.');
            });
    }

    function isResendBtnVisible() {
        return vm.hotelFaxList
            && vm.hotelFaxList.length > 0;
    }

    function onFaxSelect(id, checked) {
        if (vm.selectAll && !checked) {
            vm.selectAll = false;
        }
    }

    function getStatusIconClass(statusId) {
        const status = indexedFaxStatuses[statusId];
        return status ? status.iconClass : '';
    }

    function onSelectAll() {
        vm.faxesToResend = vm.selectAll ? vm.hotelFaxList.map(({id}) => id) : [];
    }

    function $onInit() {
        vm.faxesToResend = [];
        vm.hotelFaxList = vm.model.hotelFaxList;
        vm.total = vm.model.total;
    }

    function isResendFaxesDisabled() {
        return vm.faxesToResend.length === 0;
    }

    function isNoResultsLabelVisible() {
        return vm.hotelFaxList && vm.hotelFaxList.length === 0;
    }

    function isLoadMoreButtonVisible() {
        return vm.hotelFaxList.length < vm.total;
    }

    function loadMore() {
        const query = angular.copy($stateParams);
        const {LOAD_MORE_AMOUNT} = adminConstants;
        query.min = parseInt(query.min, 10) + LOAD_MORE_AMOUNT;
        query.max = parseInt(query.max, 10) + LOAD_MORE_AMOUNT;

        adminFaxSearchService.getFaxes(query)
            .then(({hotelFaxList}) => vm.hotelFaxList = [...vm.hotelFaxList, ...hotelFaxList]);
    }

    function navigateToFaxViewPage(fax) {
        $state.go(adminStates.FAX_DETAILS, {
            faxId: fax.id,
            referenceNo: fax.referenceNo,
            faxNumber: fax.fax,
            hash: fax.hash,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-fax/admin-fax-search-results/admin-fax-search-results-component.js